import { DynamicStringSchema } from '@a2ui/web_core/v0_9';
import { z } from 'zod';

// The catalog's props for `VIQCustomFields`, also used by the fixture tests
export const customFieldsPropsSchema = z.object({
  columns: z
    .string()
    .describe('JSON string of the inspected columns [{index, columnName, suggestedFieldType?}].')
    .optional(),
  attachmentId: z.string().describe('The attachment id of the inspected file.').optional(),
  label: DynamicStringSchema.describe('Label shown above the kept columns when displayOnly.').optional(),
  displayOnly: z.boolean().describe('Render the submitted kept columns read-only. Confirmation card only.').optional(),
  value: DynamicStringSchema.describe(
    'JSON string of the kept columns {kind, attachmentId, fields: [[index, columnName, savedName, fieldType], ...]}, ' +
      'fieldType Boolean, Date, Integer or String. Bind to a data model path; init with an empty string, the kept ' +
      'columns the user asked for, or an earlier value to reopen it. A literal when displayOnly.',
  ),
});
